import { render, staticRenderFns } from "./StickyBarPremio.vue?vue&type=template&id=0bb856bc"
import script from "./StickyBarPremio.vue?vue&type=script&lang=js"
export * from "./StickyBarPremio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports